import { Grid } from "@mui/material";
import { Custom, Field } from "components";
import { useTheme } from "contexts";
import { Conversions } from "helpers";
import { IMenu } from "interfaces";

type Props = {
  state: any;
  t: any;
  onChange: any;
  onCustomChange: any;
};

export const Fields = ({ state, t, onChange, onCustomChange }: Props) => {
  const { theme } = useTheme();

  return (
    <Grid container spacing={theme.spacing.md}>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={theme.spacing.md}>
          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="party_name"
              label={t.label.party_name}
              placeholder={t.placeholder.party_name}
              fullWidth
              value={state.party_name}
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="theme"
              label={t.label.theme}
              placeholder={t.placeholder.theme}
              fullWidth
              value={state.theme}
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Custom.TextField
              name="message"
              sx={{ mt: 0 }}
              label={t.label.message}
              placeholder={t.placeholder.message_guests}
              multiline
              rows={4}
              fullWidth
              value={state.message || ""} // Bind to potluck context
              onChange={onChange} // Update potluck state
            />
          </Grid>
          <Grid item xs={12}>
            <Custom.TextField
              name="date"
              required
              label={t.label.select_date}
              type="date"
              fullWidth
              value={state.date ? Conversions.toInputDate(state.date) : ""}
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="start_time"
              label={t.label.start_time}
              type="time"
              fullWidth
              value={
                state.start_time
                  ? Conversions.toInputTime(state.start_time)
                  : ""
              }
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="end_time"
              label={t.label.end_time}
              type="time"
              fullWidth
              value={
                state.end_time ? Conversions.toInputTime(state.end_time) : ""
              }
              onChange={onChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field.Menu.Create
          createdBy={state.created_by._id}
          menu={state.menu}
          onUpdate={(menu: IMenu[]) => onCustomChange("menu", menu)}
        />
      </Grid>
    </Grid>
  );
};
